/* eslint-disable */
export default {
  title: 'Áudio',
  input: 'Entrada',
  microphone: 'Microfone',
  autoAdjustMicLevel: 'Ajustar automaticamente o volume do microfone',
  output: 'Saída',
  speakerSource: 'Origem do altifalante',
  speakerVolume: 'Volume do altifalante',
  ringtoneSource: 'Origem do toque e da notificação',
  ringtoneVolume: 'Volume do toque e da notificação',
  ringtones: 'Toques',
  noDevices: 'Sem dispositivos',
  off: 'Desativado',
  noLabel: 'Dispositivo desconhecido',
  stopRecordDescription:
    'Diga alguma coisa para verificar o nível do seu microfone ({countDown} s)',
  stopPlaybackDescription: 'A reproduzir a sua gravação...',
  startRecordButton: 'Testar microfone',
  stopRecordButton: 'Parar gravação',
  stopPlaybackButton: 'Parar o teste',
  startTestButton: 'Testar altifalante',
  stopTestDescription: 'A reproduzir exemplo de som...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
